import BaseAgencyScopeEntityDto from "@/models/Shared/BaseAgencyScopeEntityDto";
import LocationDto from "@/models/Locations/LocationDto";

export default class DepartmentDto extends BaseAgencyScopeEntityDto {
    status = 0;
    locationId: string;
    location: LocationDto = new LocationDto();
    name = '';
    arrivalInstructions = '';
}